module.exports = __webpack_public_path__ + "static/media/gri2.3bdaf83f.jpg";